import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import ModalImage from "react-modal-image";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import SimpleBar from "simplebar-react";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetProductInventoryBranchState, getProductInventoryBranch as onGetProductInventoryBranches, addNewProductInventoryBranch as onAddNewProductInventoryBranch, updateProductInventoryBranch as onUpdateProductInventoryBranch, getProductInventoryBranchLoading } from "../../../store/productInventoryBranch/action";
import { resetTransferState, getTransfer as onGetTransfers, addNewTransfer as onAddNewTransfer, updateTransfer as onUpdateTransfer, deleteTransfer as onDeleteTransfer, getTransferLoading, resetTransferCreateState } from "../../../store/transfer/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { resetClientState, getClient } from "../../../store/client/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Transfer = () => {
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalOutbound, setModalOutbound] = useState(false);
  const [modalTransfer, setModalTransfer] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");

  const [productInventoryList, setProductInventoryList] = useState([]);
  const [productSelectInventoryList, setProductSelectInventoryList] = useState([]);
  const [productInventoryDetailItem, setProductInventoryDetailItem] = useState([]);
  const [civil_budgetList, setProductionList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [materialList, setMaterialList] = useState([]);

  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    productInventoryLoading,
    productInventories,
    isProductInventoryCreated,
    isProductInventorySuccess,
    clients,
    clientLoading,
    transfers,
    transferAdded,
    isTransferCreated,
    isTransferSuccess,
    loading,
    error,
    companies,
    companyLoading,
    shipmentMethods,
    shipmentMethodLoading,
    shipmentCarriers,
    shipmentCarrierLoading,
    branches,
    branchLoading,
    productVarians,
    productVarianLoading,
    productInventoryBranches,
    productInventoryBranchAdded,
    isProductInventoryBranchCreated,
    isProductInventoryBranchSuccess,
    productInventoryBranchLoading,
    civilBudgets,
    civilBudgetLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    transferAdded: state.Transfer.transferAdded,
    transfers: state.Transfer.transfers,
    isTransferCreated: state.Transfer.isTransferCreated,
    isTransferSuccess: state.Transfer.isTransferSuccess,
    loading: state.Transfer.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    shipmentMethods: state.ShipmentMethod.shipmentMethods,
    shipmentMethodLoading: state.ShipmentMethod.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
    shipmentCarrierLoading: state.ShipmentCarrier.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Transfer.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    productInventories: state.ProductInventory.productInventories,
    isProductInventoryCreated: state.ProductInventory.isProductInventoryCreated,
    isProductInventorySuccess: state.ProductInventory.isProductInventorySuccess,
    productInventoryLoading: state.ProductInventory.loading,
    productInventoryBranchAdded: state.ProductInventoryBranch.productInventoryBranchAdded,
    productInventoryBranches: state.ProductInventoryBranch.productInventoryBranches,
    isProductInventoryBranchCreated: state.ProductInventoryBranch.isProductInventoryBranchCreated,
    isProductInventoryBranchSuccess: state.ProductInventoryBranch.isProductInventoryBranchSuccess,
    productInventoryBranchLoading: state.ProductInventoryBranch.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
  }));

  const [transferList, setTransferList] = useState([]);
  const [transfer, setTransfer] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusTransfer, setStatusTransfer] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [originalFiles, setOriginalFiles] = useState([]);
  const [productList, setProductList] = useState([]);
  const [transferDetailItem, setTransferDetailItem] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetMaterialList, setCivilBudgetMaterialList] = useState([]);
  const [invDocImg, setInvDocImg] = useState([]);
  const [transferDoc, setTransferDoc] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditOutbound, setIsEditOutbound] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchIdSelected, setBranchIdSelected] = useState(null);

  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [modalMedia, setModalMedia] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTransfers = transfers;
      if (type !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === type);
      }
      setTransferList(filteredTransfers);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ companyId: companySelected?.value ?? "", branchId: branchSelected?.value ?? "" }));
      handleGetShipmentMethod(companySelected?.value);
      handleGetShipmentCarrier(companySelected?.value);
      handleGetCivilBudget(companySelected?.value);
      handleGetProductVariant(companySelected?.value);
      setBranchIdSelected(branchSelected?.value);
      dispatch(onGetProductInventoryBranches({ branchId: branchSelected?.value, type: "inbound-product" }));
    }
  }, [branchSelected, companySelected]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetCivilBudget = (companyId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId }));
  };

  const handleGetBranch = useCallback(
    (id) => {
      dispatch(resetBranchState());
      dispatch(getBranch({ companyId: id, status: 2 }));
    },
    [dispatch]
  );

  const handleGetShipmentCarrier = (companyId) => {
    dispatch(resetShipmentCarrierState());
    dispatch(getShipmentCarrier({ companyId: companyId, status: 2, type: "Transfer" }));
  };

  const handleGetShipmentMethod = (companyId) => {
    dispatch(resetShipmentMethodState());
    dispatch(getShipmentMethod({ companyId: companyId, status: 2, type: "Transfer" }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      let productVarianData = [];
      let blockData = [];
      let opt = [];
      let block = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product;
        const blck = varian.product_block ? varian.product_block.id : "";
        const blck_name = varian.product_block ? varian.product_block.name : "";
        const name = blck_name + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const brandId = item.brandId;
        const productId = item.productId;
        const branch = varian.branchId ? varian.branchId : "";

        if (item.typeId === 1) {
          if (branchIdSelected === branch) {
            opt.push({ label: name, name: name, barcode: barcode, sku: sku, value: id, brandId: brandId, productId: productId });
            const dataBlock = block.find((d) => d.value === blck);
            if (!dataBlock) block.push({ label: blck_name, value: blck });
          }
        }
      });
      let option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);

      let option_block = { options: block };
      blockData.push(option_block);
      setBlockList(blockData);
    }
  }, [productVarians, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(productInventoryBranches)) {
      let materialVarianData = [];
      let opt_material = [];
      productInventoryBranches.forEach((item, key) => {
        const varian = item.inv_branch_varian;
        const product = item.inv_branch_product;
        const allocated = isNaN(parseFloat(item.allocated)) ? 0 : parseFloat(item.allocated);
        const stocks = isNaN(parseFloat(item.stocks)) ? 0 : parseFloat(item.stocks);
        const onhand = stocks - allocated;
        opt_material.push({ label: product.name, stock: item.stocks, allocated: allocated, onhand: onhand, uom: product?.product_uom?.name, name: varian.name, barcode: varian.barcode, sku: varian.sku, value: varian.id, brandId: varian.brandId, productId: varian.productId, productInventoryBranchId: item.id });

      });
      let option_material = { options: opt_material.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      materialVarianData.push(option_material);
      setMaterialList(materialVarianData);
    }
  }, [productInventoryBranches]);

  const transferMultiple = () => {
    if (validation?.values?.branch === "") return toast.error("Failed, Please pick company and branch", { autoClose: 3000 });

    const copyProductInventoryList = [...productInventoryList];
    let dataListFilter = copyProductInventoryList.filter((el) => el.checked === true);
    if (dataListFilter.length < 1) return toast.error("Failed, Please checked product", { autoClose: 3000 });

    let dataListResult = [];

    dataListFilter.forEach((el) => {
      let element = el.inv_branch_varian;
      let prod = el.inv_branch_product;
      let option_name = "";
      element.pvar_options &&
        element.pvar_options.forEach((i) => {
          option_name += i.name + "/";
        });
      let onhand = Number(el.stocks) - Number(el.allocated);
      if (onhand > 0) {
        dataListResult.push({
          detailId: el.id,
          itemId: element.id,
          item: { label: prod.name + " " + option_name.slice(0, -1) + " - " + element.barcode, value: element.id, name: prod.name + " " + option_name.slice(0, -1), sku: element.sku, barcode: element.barcode, price: element.price, brandId: element.brandId, productId: prod.id },
          amount: parseFloat(element.price),
          quantity: parseFloat(onhand),
          onhand: parseFloat(onhand),
          total: 0,
          name: prod.name,
          uom: prod?.transfer_detail_product?.product_uom?.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
        });
      }
    });

    setProductInventoryDetailItem(dataListResult);
    toggleTransfer();
  };

  useEffect(() => {
    setProductInventoryList(productInventoryBranches);
  }, [productInventoryBranches]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let filteredTransfers = transfers;
      if (activeTypeTab !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === activeTypeTab);
      }
      setTransferList(filteredTransfers.map((el) => ({ ...el, isChecked: false })));
    }
    else
    {
      setTransferList([]);
    }
  }, [transfers]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal Keluar",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_from",
        label: "Pengirim",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_to",
        label: "Penerima",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Sistem",
        isSelected: true,
        data: [],
      },
      {
        id: "budget",
        label: "Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan",
        label: "Pekerjaan",
        isSelected: true,
        data: [],
      },
      {
        id: "block",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "material",
        label: "Material",
        isSelected: true,
        data: [],
      },
      {
        id: "volume",
        label: "Volume",
        isSelected: true,
        data: [],
      },
      {
        id: "uom",
        label: "Satuan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (transferList.length > 0) {
      transferList.forEach((transfer) => {
        if (transfer.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(transfer.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          if (doc) doc.data.push(handleValidDate(transfer.transactionat));

          doc = dataDoc.find((d) => d.id === "transfer_from");
          if (doc) doc.data.push(transfer?.transfer_from?.name);

          doc = dataDoc.find((d) => d.id === "transfer_to");
          if (doc) doc.data.push(transfer?.transfer_to?.name || transfer?.type);

          doc = dataDoc.find((d) => d.id === "block");
          if (doc) doc.data.push(transfer?.transfer_block?.name);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(transfer?.description);

          transfer.transfer_detail.forEach((item, idx) => {
            if (!first) {
              doc = dataDoc.find((d) => d.id === "transfer_from");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transfer_to");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transaction_no");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transactionat");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "block");
              if (doc) doc.data.push(transfer?.transfer_block?.name);
            }
            first = false;

            doc = dataDoc.find((d) => d.id === "budget");
            if (doc) doc.data.push(item?.transfer_cvl_account?.name);

            doc = dataDoc.find((d) => d.id === "pekerjaan");
            if (doc) doc.data.push(item?.transfer_cvl_account_job?.name);

            doc = dataDoc.find((d) => d.id === "material");
            if (doc) doc.data.push(item.name);

            doc = dataDoc.find((d) => d.id === "volume");
            if (doc) doc.data.push(parseFloat(item.quantity));

            doc = dataDoc.find((d) => d.id === "uom");
            if (doc) doc.data.push(item?.transfer_detail_product?.product_uom?.name);

          });
        }
      });
    }
    setTransferDoc(dataDoc);
  }, [transferList]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      let civilBudgetMaterialData = [];
      let optMaterial = [];
      let civilBudgetData = [];
      let opt = [];
      civilBudgets.forEach((it, idx) => {
        if (branchIdSelected === it.branchId) {
          it.cvl_detail.forEach((item, key) => {
            const name = item.cvld_account ? it.type + " - " + item?.cvld_account?.name : "";
            const id = item.cvld_account ? item.cvld_account.id : "";
            let obj = { label: name, value: id, cvl_account_job: item?.cvld_account?.name, cvl_account: name, name: item?.cvld_account?.name, type: it.type, civilBudgetDetailId: item.id, civilBudgetId: it.id, civilAccountId: id, cvlBudgetDetailId: item.id, cvlBudgetId: it.id, cvlAccountId: id, material: item.cvld_material };
            if (it.type === "PROGRESS BANGUNAN") {
              obj = { label: item?.cvld_account?.name, value: id, cvl_account_job: item?.cvld_account?.name, cvl_account: name, name: item?.cvld_account?.name, type: it.type, civilBudgetDetailId: item.id, civilBudgetId: it.id, civilAccountId: id, cvlBudgetDetailId: item.id, cvlBudgetId: it.id, cvlAccountId: id, material: item.cvld_material };
              opt.push(obj);
            } else {
              if (item.cvld_material && item.cvld_material.length > 0) {
                optMaterial.push(obj);
              }
            }
          });
        }
      });
      let option = { options: opt };
      let option_material = { options: optMaterial };
      civilBudgetData.push(option);
      civilBudgetMaterialData.push(option_material);
      setCivilBudgetList(civilBudgetData);
      setCivilBudgetMaterialList(civilBudgetMaterialData);
    }
    else {
      setCivilBudgetList([]);
      setCivilBudgetMaterialList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  useEffect(() => {
    setTransfer(transferAdded);
  }, [transferAdded]);

  useEffect(() => {
    let data = [];
    let opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      let obj = { label: name, value: id };
      opt.push(obj);
    });
    let option = { options: opt };
    data.push(option);
    setBranchList(data);
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      let data = [];
      let opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      let data = [];
      let opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      let data = [];
      let opt = [];
      shipmentCarriers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      let data = [];
      let opt = [];
      shipmentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  const onClickDelete = (transfer) => {
    setTransfer(transfer);
    setDeleteModal(true);
  };

  const handleDeleteTransfer = () => {
    if (transfer) {
      dispatch(onDeleteTransfer(transfer));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTransfer(null);
      setOriginalFiles([]);
      setInvDocImg([]);
      setTransferDetailItem([]);
      validation.resetForm();
    } else {
      setProductInventoryList([]);
      setModal(true);
    }
  }, [modal]);

  const toggleOutbound = useCallback(() => {
    if (modalOutbound) {
      setModalOutbound(false);
      setTransfer(null);
      setOriginalFiles([]);
      setInvDocImg([]);
      setTransferDetailItem([]);
      validationOutbound.resetForm();
    } else {
      setModalOutbound(true);
    }
  }, [modalOutbound]);

  const toggleTransfer = useCallback(() => {
    if (modalTransfer) {
      setIsEdit(false);
      setModalTransfer(false);
      setInvDocImg([]);
      setOriginalFiles([]);
      setProductInventoryDetailItem([]);
      setProductSelectInventoryList([]);
    } else {
      setModalTransfer(true);
    }
  }, [modalTransfer]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTransfer(null);
      setOriginalFiles([]);
      setTransferDetailItem([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleTransferClick = useCallback(
    (arg, type) => {
      const data = arg;
      const param = { branchId: data.fromBranchId };
      dispatch(onGetProductInventoryBranches(param));
      let transferDetailList = [];
      if (data.transfer_detail !== null) {
        data.transfer_detail.forEach((e) => {
          const bcode = e.barcode === null ? 0 : e.barcode;
          transferDetailList.push({
            detailId: e.productInventoryBranchId,
            itemId: e.productVarianId,
            item: { label: e.name + " - " + bcode, uom: e?.transfer_detail_product?.product_uom?.name, value: e.productVarianId, name: e.name, sku: e.sku, barcode: bcode, price: e.price, brandId: e.brandId, productId: e.productId },
            amount: parseFloat(e.price),
            quantity: parseFloat(e.quantity),
            onhand: parseFloat(e.quantity),
            uom: e?.transfer_detail_product?.product_uom?.name,
            total: 0,
            name: e.name,
            sku: e.sku,
            barcode: bcode,
            brandId: e.brandId,
          });
        });
      }
      setProductInventoryDetailItem(transferDetailList);

      let files = [];
      for (const f of data.transfer_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setInvDocImg(files);

      let civil_budgetList = [];
      if (data.transfer_detail) {
        data.transfer_detail.forEach((element) => {
          const bcode = element.barcode === null ? 0 : element.barcode;
          civil_budgetList.push({
            detailId: element.productInventoryBranchId,
            itemId: element.productVarianId,
            item: { label: element.name + " - " + bcode, uom: element?.transfer_detail_product?.product_uom?.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: bcode, price: element.price, brandId: element.brandId, productId: element.productId },
            amount: parseFloat(element.price),
            quantity: parseFloat(element.quantity),
            onhand: parseFloat(element.quantity),
            disable: false,
            total: 0,
            uom: element?.transfer_detail_product?.product_uom?.name,
            name: element.name,
            sku: element.sku,
            barcode: bcode,
            brandId: element.brandId,

            cvl_account: element?.transfer_cvl_budget?.cvld_account?.name,
            cvl_account_job: element?.transfer_cvl_budget_job?.cvld_account?.name,
            type: element?.transfer_cvl_budget?.type,
            cvl_label: element?.transfer_cvl_budget?.cvld_account?.name,
            civilBudgetId: element?.civilBudgetId,
            civilBudgetDetailId: element?.civilBudgetDetailId,
            civilAccountId: element?.civilAccountId,
            cvlBudgetId: element?.cvlBudgetId,
            cvlBudgetDetailId: element?.cvlBudgetDetailId,
            cvlAccountId: element?.cvlAccountId,
          });
        });
      }
      setProductionList(civil_budgetList);

      let arrUnit = [];
      if (data.unit) {
        data.unit.forEach((item) => {
          let obj = { label: item.name, name: item.name, barcode: item.barcode, sku: item.sku, value: item.productId, price: item.price, brandId: item.brandId, productId: item.productId };
          arrUnit.push(obj);
        });
      }

      setTransfer({
        id: data.id,
        code: data.code,
        transaction_no: data.transaction_no,
        transactionat: data.transactionat,
        shipment_amount: data.shipment_amount,
        description: data.description,
        unit: arrUnit,
        shipment_code: data.shipment_code,
        items: civil_budgetList,
        transfer_file: data.transfer_file,
        block: data.transfer_block && {
          label: data.transfer_block.name,
          value: data.transfer_block.id,
        },
        civilBudget: data.transfer_cvl_budget && {
          label: data.transfer_cvl_budget.cvld_account ? data.transfer_cvl_budget.cvld_account.name : "",
          value: data.transfer_cvl_budget.cvld_account ? data.transfer_cvl_budget.cvld_account.id : "",
          civilBudgetDetailId: data.transfer_cvl_budget.id,
          material: data.transfer_cvl_budget.cvld_material,
        },
        client: data.transfer_client && {
          label: data.transfer_client.name,
          value: data.transfer_client.id,
        },
        company: data.transfer_company && {
          label: data.transfer_company.name,
          value: data.transfer_company.id,
        },
        branch: data.transfer_from && {
          label: data.transfer_from.name,
          value: data.transfer_from.id,
        },
        toBranch: data.transfer_to && {
          label: data.transfer_to.name,
          value: data.transfer_to.id,
        },
        shipment_carrier: data.transfer_shipment_carrier && {
          label: data.transfer_shipment_carrier.name,
          value: data.transfer_shipment_carrier.id,
        },
        shipment_method: data.transfer_shipment_method && {
          label: data.transfer_shipment_method.name,
          value: data.transfer_shipment_method.id,
        },
      });

      switch (type) {
        case "detail":
          toggleDetail();
          break;
        default:
          if (data.type === "Production") {
            setIsEditOutbound(true);
            toggleOutbound();
          } else {
            setIsEdit(true);
            toggle();
          }
          break;
      }
    },
    [dispatch, handleGetBranch, toggleDetail, toggle]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = transferList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setTransferList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    width: 10,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = transferList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setTransferList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className="btn-sm"
                onClick={() => {
                  handleTransferClick(data, "detail");
                  setInfo(data);
                  setModalDetail(true);
                }}>
                <i className="ri-eye-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className="btn-sm"
                onClick={() => {
                  setInfo(data);
                  toggleHistory();
                }}>
                <i className=" ri-history-line fs-15"></i>
              </Button>
              {parseInt(cellProps.row.original.statusId) < 2 && (
                <>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateMaterialTransfer") !== -1 ? "btn-sm" : "d-none"}
                    onClick={() => {
                      handleTransferClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteMaterialTransfer") !== -1 ? "btn-sm" : "d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </>
              )}
              <DropdownToggle tag="button" className={data.statusId === 5 || data.statusId === 6 || data.statusId === 7 ? "d-none" : "btn btn-sm btn-light"} split></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    data.actionTitle = `You are going to set transfer transaction of ${data.transfer_to?.name} #${data.code} as COMPLETED`;
                    data.statusTransferId = 5;
                    setTransfer(data);
                    toggleApprove();
                  }}
                >
                  COMPLETED
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  onClick={() => {
                    data.actionTitle = `You are going to CANCEL transfer transaction of ${data.transfer_to?.name}  #${data.code} `;
                    data.statusTransferId = 6;
                    setTransfer(data);
                    toggleApprove();
                  }}
                >
                  CANCELED
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    data.actionTitle = `You are going to set transfer transaction of ${data.transfer_to?.name} #${data.code} as RETURNED`;
                    data.statusTransferId = 7;
                    setTransfer(data);
                    toggleApprove();
                  }}
                >
                  RETURNED
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </ButtonGroup>

          {/* {cellProps.row.original.statusId === 1 && (
              <button
                className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                onClick={() => {
                  let data = cellProps.row.original;
                  data.statusTransferId = 2;
                  setTransfer(data);
                  toggleApprove();
                }}><i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> APPROVE</button>
            )} */}

          {(cellProps.row.original.statusId === 1 || cellProps.row.original.statusId === 2) && (
            <button
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveMaterialTransfer") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "d-none"}
              onClick={() => {
                let data = cellProps.row.original;
                data.statusTransferId = 4;
                setTransfer(data);
                toggleApprove();
              }}
            >
              <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
              {"CONFIRM"}
            </button>
          )}
        </div>
      );
    },
  },
  {
    Header: "Transfer No",
    accessor: "transaction_no",
    width: 10,
    filterable: true,
    Cell: (cellProps) => (
      <Link
        to="#"
        className="fw-semibold"
        onClick={() => {
          let data = cellProps.row.original;
          handleTransferClick(data, "detail");
        }}>
        {cellProps.row.original.transaction_no}
      </Link>
    ),
  },
  {
    id: "Tanggal",
    Header: "Tanggal",
    accessor: "transactionat",
    width: 10,
    filterable: false,
    Cell: (data) => {
      return handleValidDate(data.row.original.transactionat);
    },
  },
  {
    Header: "Tipe",
    accessor: "type",
    width: 10,
    filterable: true,
    Cell: (cell) => {
      return <span className={cell.value === "Production" ? "badge text-uppercase badge-soft-warning" : "badge text-uppercase badge-soft-primary"}> {cell.value}</span>;
    },
  },
  {
    Header: "BloK",
    accessor: "transfer_block.name",
    width: 5,
    filterable: true,
  },
  {
    Header: "Pengirim",
    accessor: "transfer_from.name",
    width: 25,
    filterable: true,
  },
  {
    Header: "Penerima",
    accessor: "transfer_to.name",
    width: 25,
    filterable: true,
  },
  {
    Header: "Qty ",
    accessor: "sub_amount",
    width: 10,
    filterable: true,
    Cell: (data) => {
      let qty = 0;
      data.row.original.transfer_detail.forEach((element) => {
        qty += parseFloat(element.quantity, 2);
      });
      return <span className="fw-semibold">{qty}</span>;
    },
  },
  {
    id: "Detail",
    Header: "Detail",
    accessor: (data) => JSON.stringify(data.transfer_detail),
    filterable: true,
  },
  {
    Header: "Status",
    width: 10,
    accessor: "transfer_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
        case "CONFIRMED":
          return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
        case "SHIPPED":
          return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
        case "RECEIVED":
          return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
        case "COMPLETED":
          return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
        default:
          return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
      }
    },
  },
  ],
    [transferList, handleTransferClick, toggleApprove, toggleHistory, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = transferList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setTransferList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => transferList, [transferList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Detail"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [{ id: "Tanggal", desc: true }],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    let status = statusTransfer.value ? statusTransfer.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "",
      branchId: branchSelected.value,
    };
    dispatch(onGetTransfers(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setTransferList([]);
    setSearchValue("");
    setStatusTransfer([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetTransferState());
    dispatch(onGetTransfers({ companyId: companySelected?.value ?? "", branchId: branchSelected.value ?? "" }));
  };

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (transfer) {
        transfer.setApprove = true;
        transfer.approval_note = values.approval_note;
        dispatch(onUpdateTransfer(transfer));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (transfer && transfer.client) || clientSelected,
      company: (transfer && transfer.company) || companySelected,
      id: (transfer && transfer.id) || 0,
      description: (transfer && transfer.description) ?? "",
      branch: (transfer && transfer.branch) || branchSelected,
      toBranch: (transfer && transfer.toBranch) ?? "",
      shipment_carrier: (transfer && transfer.shipment_carrier) ?? "",
      shipment_method: (transfer && transfer.shipment_method) ?? "",
      shipment_amount: (transfer && transfer.shipment_amount) ?? "",
      shipment_code: (transfer && transfer.shipment_code) ?? "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      if (isEdit) {
        let dataEdit = {
          id: values.id,
          statusTransferId: 1,
          type: "Distribution",
          description: values.description,
          clientId: values.client.value,
          shipment_amount: values.shipment_amount,
          shipment_code: values.shipment_code,
          companyId: values.company.value,
          fromBranchId: values.branch.value,
          toBranchId: values.toBranch.value,
          shipmentCarrierId: values.shipment_carrier.value,
          shipmentMethodId: values.shipment_method.value,
          transfer_detail: productInventoryDetailItem.length > 0 ? JSON.stringify(productInventoryDetailItem) : "[]",
          files: invDocImg.length > 0 ? invDocImg : [],
        };
        dispatch(onUpdateTransfer(dataEdit));
        toggle();
        toggleTransfer();
      } else {
        let dataSubmit = {
          statusTransferId: 1,
          type: "Distribution",
          description: values.description,
          clientId: values.client.value,
          shipment_amount: values.shipment_amount,
          shipment_code: values.shipment_code,
          companyId: values.company.value,
          fromBranchId: values.branch.value,
          toBranchId: values.toBranch.value,
          shipmentCarrierId: values.shipment_carrier.value,
          shipmentMethodId: values.shipment_method.value,
          transfer_detail: productInventoryDetailItem.length > 0 ? JSON.stringify(productInventoryDetailItem) : "[]",
          files: invDocImg.length > 0 ? invDocImg : [],
        };
        dispatch(onAddNewTransfer(dataSubmit));
        toggle();
        toggleTransfer();
      }
      validation.resetForm();
    },
  });

  const validationOutbound = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (transfer && transfer.client) || clientSelected,
      company: (transfer && transfer.company) || companySelected,
      transactionat: (transfer && transfer.transactionat) ?? "",
      id: (transfer && transfer.id) || 0,
      description: (transfer && transfer.description) ?? "",
      branch: (transfer && transfer.branch) || branchSelected,
      toBranch: (transfer && transfer.toBranch) ?? "",
      block: (transfer && transfer.block) ?? "",
      unit: (transfer && transfer.unit) ?? "",
      civilBudget: (transfer && transfer.civilBudget) ?? "",
      items: (transfer && transfer.items) ?? "",
      shipment_carrier: (transfer && transfer.shipment_carrier) ?? "",
      shipment_method: (transfer && transfer.shipment_method) ?? "",
      shipment_amount: (transfer && transfer.shipment_amount) ?? "",
      shipment_code: (transfer && transfer.shipment_code) ?? "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      if (isEditOutbound) {
        let dataEdit = {
          id: values.id,
          statusTransferId: 1,
          type: "Production",
          transactionat: values.transactionat,
          description: values.description,
          clientId: values.client.value,
          shipment_amount: values.shipment_amount,
          shipment_code: values.shipment_code,
          companyId: values.company.value,
          fromBranchId: values.branch.value,
          toBranchId: values.toBranch.value,
          shipmentCarrierId: values.shipment_carrier.value,
          shipmentMethodId: values.shipment_method.value,
          civilBudgetDetailId: values.civilBudget.civilBudgetDetailId,
          unit: values.unit,
          blockId: values.block.value,
          transfer_detail: JSON.stringify(values.items) || [],
          files: invDocImg.length > 0 ? invDocImg : [],
        };
        dispatch(onUpdateTransfer(dataEdit));
        toggleOutbound();
      } else {
        let dataSubmit = {
          statusTransferId: 1,
          type: "Production",
          transactionat: values.transactionat,
          description: values.description,
          clientId: values.client.value,
          shipment_amount: values.shipment_amount,
          shipment_code: values.shipment_code,
          companyId: values.company.value,
          fromBranchId: values.branch.value,
          toBranchId: values.toBranch.value,
          shipmentCarrierId: values.shipment_carrier.value,
          shipmentMethodId: values.shipment_method.value,
          civilBudgetDetailId: values.civilBudget.civilBudgetDetailId,
          unit: values.unit,
          blockId: values.block.value,
          transfer_detail: JSON.stringify(values.items) || [],
          files: invDocImg.length > 0 ? invDocImg : [],
        };

        dispatch(onAddNewTransfer(dataSubmit));
        toggleOutbound();
      }
      validationOutbound.resetForm();
    },
  });

  const checkedAllInventory = () => {
    const copyProductInventoryList = [...productInventoryList];
    const checkall = document.getElementById("checkBoxAllInventory");
    const ele = document.querySelectorAll(".dataCheckboxInventory");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });

      copyProductInventoryList.forEach((el) => {
        let allocated = !isNaN(parseFloat(el.allocated)) ? parseFloat(el.allocated) : 0;
        if (parseFloat(el.stocks) - allocated > 0) {
          el.checked = true;
        } else {
          el.checked = false;
        }
      });

      setProductInventoryList(copyProductInventoryList);
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });

      copyProductInventoryList.forEach((el) => {
        el.checked = false;
      });

      setProductInventoryList(copyProductInventoryList);
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteTransfer(element.value));
    });
    checkall.checked = false;
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = invDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setInvDocImg(newState);
    } else {
      const index = invDocImg.findIndex((fl) => fl.filename === file.filename);
      setInvDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setInvDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  useEffect(() => {
    const checkall = document.getElementById("checkBoxAllInventory");
    const resultF = productInventoryList.every((el) => el.checked !== true);
    if (checkall !== null) {
      if (resultF) {
        checkall.checked = false;
      }
    }
  }, [productInventoryList]);

  const onClickDeleteDetailItem = (index) => {
    validationOutbound.values.items.splice(index, 1);
    validationOutbound.setFieldValue("items", validationOutbound.values.items);
  };

  const handleBtnQtyDetail = (type, i) => {
    const qty = validationOutbound.values.items[i].quantity;
    if (type === "add") {
      let val = qty + 1;
      validationOutbound.values.items[i].quantity = validationOutbound.values.items[i].onhand > val ? val : validationOutbound.values.items[i].onhand;
    } else if (type === "reduce") {
      let val = qty - 1;
      validationOutbound.values.items[i].quantity = val > 0 ? val : 0;
    }
  };

  const handleQuantityDetail = (e, i) => {
    let val = e.target.value;
    if (!isNaN(val)) {
      validationOutbound.values.items[i].quantity = validationOutbound.values.items[i].onhand > val ? val : validationOutbound.values.items[i].onhand;
    } else {
      validationOutbound.values.items[i].quantity = 0;
    }
  };

  const handleTransferDetailAdd = () => {
    validationOutbound.setFieldValue("items", [
      ...validationOutbound.values.items,
      {
        detailId: 0,
        itemId: 0,
        item: {
          label: "Pilih Material",
          value: 0,
          name: "Pilih Material",
          sku: "",
          uom: "",
          barcode: "",
          amount: 0,
          brandId: 0,
          productId: 0,
        },
        amount: 0,
        onhand: 0,
        quantity: 0,
        total: 0,
        uom: "",
        name: "",
        disable: false,
        sku: "",
        barcode: "",
        brandId: 0,
        cvl_account_job: "",
        cvl_account: "",
        type: "",
        cvl_label: "",
        civilBudgetId: 0,
        civilBudgetDetailId: 0,
        civilAccountId: 0,
        cvlBudgetId: 0,
        cvlBudgetDetailId: 0,
        cvlAccountId: 0,
      },
    ]);
  };

  const handleTransferDetailAddByBudget = (e) => {
    let materialVarianData = [];
    let arr = [];

    validationOutbound.setFieldValue("items", [
      ...validationOutbound.values.items,
      {
        detailId: 0,
        itemId: 0,
        item: {
          label: "Pilih Material",
          value: 0,
          name: "Pilih Material",
          sku: "",
          uom: "",
          barcode: "",
          amount: 0,
          brandId: 0,
          productId: 0,
        },
        amount: 0,
        onhand: 0,
        quantity: 0,
        total: 0,
        uom: "",
        name: "",
        disable: false,
        sku: "",
        barcode: "",
        brandId: 0,
        type: e.type,
        cvl_label: "",
        civilAccountId: e.civilAccountId,
        civilBudgetId: e.civilBudgetId,
        civilBudgetDetailId: e.civilBudgetDetailId,
        cvl_account: e.name,
        cvl_account_job: "Pilih Pekerjaan",
      },
    ]);

    // for (const item of e.material) {
    //   let findStock = productInventoryList.find((d) => d.productId === item.productId);
    //   if (findStock) {
    //     const varian = findStock.inv_branch_varian;
    //     const product = findStock.inv_branch_product;
    //     const allocated = isNaN(parseFloat(findStock.allocated)) ? 0 : parseFloat(findStock.allocated);
    //     const stocks = isNaN(parseFloat(findStock.stocks)) ? 0 : parseFloat(findStock.stocks);
    //     const onhand = stocks - allocated;
    //     const quantity = validationOutbound.values.unit.length ? parseFloat(item.quantity * validationOutbound.values.unit.length) : 0;
    //     arr.push({
    //       detailId: findStock.id,
    //       itemId: varian.id,
    //       item: { label: product.name, stock: findStock.stocks, allocated: allocated, onhand: onhand, name: product.name, barcode: varian.barcode, sku: varian.sku, value: varian.id, brandId: varian.brandId, productId: varian.productId, productInventoryBranchId: findStock.id },
    //       amount: 0,
    //       civilAccountId: e.civilAccountId,
    //       civilBudgetId: e.civilBudgetId,
    //       civilBudgetDetailId: e.civilBudgetDetailId,
    //       quantity: onhand > quantity ? quantity : onhand,
    //       quantity_need: quantity,
    //       stock: onhand,
    //       name: product.name,
    //       uom: product?.product_uom?.name,
    //       label: product.name,
    //       type: e.type,
    //       cvl_account: e.name,
    //       cvl_account_job: "Pilih Pekerjaan",
    //       onhand: onhand,
    //       disable: false,
    //       sku: varian.sku,
    //       barcode: varian.barcode,
    //       brandId: varian.brandId,
    //     });
    //   } else {
    //     toast.error(`${item?.cvlm_material?.name} BELUM PERNAH DIBELI`, { autoClose: 1000 });
    //   }
    // }
    // let option_material = { options: arr.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
    // materialVarianData.push(option_material);
    // setMaterialList(materialVarianData);
    // if (arr.length > 0) {
    //   let newArr = [];
    //   newArr.push(arr[0]);
    //   for (const obj of validationOutbound.values.items) {
    //     newArr.push(obj);
    //   }
    //   validationOutbound.setFieldValue("items", newArr);
    // }
  };
  document.title = "Transfer Request | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transferList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTransfer} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Distribusi Material" loading={loading}>
          {" "}
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-warning add-btn me-1" : userRole && userRole.split(",").indexOf("createMaterialTransfer") !== -1 ? "btn btn-warning add-btn me-1" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEditOutbound(false);
                setTransfer(null);
                setOriginalFiles([]);
                setInvDocImg([]);
                setTransferDetailItem([]);
                validationOutbound.resetForm();
                toggleOutbound();
              }}
            >
              <i className="ri-barcode-box-line me-1 align-bottom fs-14"></i> PENGELUARAN BARANG
            </button>
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createMaterialTransfer") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                setTransfer(null);
                setOriginalFiles([]);
                setInvDocImg([]);
                setTransferDetailItem([]);
                validation.resetForm();
                toggle();
              }}
            >
              <i className="ri-refresh-line me-1 align-bottom fs-14"></i> TRANSFER BARANG
            </button>
            <ExportDoc data={transferDoc} />
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "SHIPPED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> SHIPPED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("5", "RECEIVED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RECEIVED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("7", "CANCELED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("8", "RETURNED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()} style={column.width ? { width: column.width + "%" } : {}}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          const detail = JSON.parse(row.values.Detail);
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                              {(detail || [])
                                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                                .map((o, i) => {
                                  return (
                                    <tr key={i} className="bg-light">
                                      <td colSpan={4} className="p-2"></td>
                                      <td colSpan={5} className="text-start fs-12 p-2">
                                        {o.name} - {o?.transfer_cvl?.name} {o?.transfer_cvl_account_job?.name || o?.transfer_cvl_account?.name} { }{" "}
                                        <span className="text-muted ms-2">
                                          ({parseFloat(o.quantity)} {o.transfer_detail_product?.product_uom?.name})
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Transfer Persediaan" : "Tambah Transfer Persediaan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Row>
                        <Col xxl={12}>
                          <div>
                            <div className="card-header border-0 mb-3">
                              <div className="d-flex align-items-center">
                                <h5 className="card-title mb-0 flex-grow-1">
                                  Daftar Persediaan Produk &nbsp;
                                  {(loading || productInventoryBranchLoading) && (
                                    <>
                                      <Spinner color="primary" type="grow" size={"sm"}>
                                        Loading...
                                      </Spinner>
                                      &nbsp;
                                      <Spinner color="success" type="grow" size={"sm"}>
                                        Loading...
                                      </Spinner>
                                      &nbsp;
                                    </>
                                  )}
                                </h5>
                                <div className="d-flex gap-2">
                                  <div className="d-flex gap-2">
                                    <div>
                                      <div>
                                        <div className="position-relative">
                                          <Select
                                            name="client"
                                            value={validation.values.client}
                                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                                            placeholder="Pilih Grup Usaha"
                                            onChange={(e) => {
                                              setBranchList([]);
                                              validation.setFieldValue("branch", "");
                                              setCompanyList([]);
                                              validation.setFieldValue("company", "");
                                              validation.setFieldValue("client", e);
                                              handleGetCompany(e.value);
                                            }}
                                            options={clientList}
                                          ></Select>
                                          <div className="position-absolute" style={{ top: "12px", left: "-34px" }}>
                                            {clientLoading && (
                                              <Spinner color="primary" size="sm">
                                                Loading...
                                              </Spinner>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                      <div>
                                        <div className="position-relative">
                                          <Select
                                            name="company"
                                            value={validation.values.company}
                                            placeholder="Pilih Perusahaan"
                                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                                            onChange={(e) => {
                                              setBranchList([]);
                                              validation.setFieldValue("branch", "");
                                              validation.setFieldValue("company", e);
                                              handleGetBranch(e.value);
                                              handleGetShipmentMethod(e.value);
                                              handleGetShipmentCarrier(e.value);
                                            }}
                                            options={companyList}
                                          ></Select>
                                          <div className="position-absolute" style={{ top: "12px", left: "-34px" }}>
                                            {companyLoading && (
                                              <Spinner color="primary" size="sm">
                                                Loading...
                                              </Spinner>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                      <div>
                                        <div className="position-relative" style={{ width: "320px" }}>
                                          <Select
                                            name="branch"
                                            placeholder="Pilih Proyek / Cabang"
                                            value={validation?.values?.branch}
                                            onChange={(e) => {
                                              validation.setFieldValue("branch", e);
                                              const param = {
                                                branchId: e.value,
                                                type: "inbound-product",
                                              };
                                              dispatch(onGetProductInventoryBranches(param));
                                            }}
                                            options={branchList}
                                          ></Select>
                                          <div className="position-absolute" style={{ top: "12px", left: "-34px" }}>
                                            {branchLoading && (
                                              <Spinner color="primary" size="sm">
                                                Loading...
                                              </Spinner>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="pt-0">
                              <div className="row">
                                <div className="col-lg-12">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th scope="col">
                                          <input type="checkbox" id="checkBoxAllInventory" className="form-check-input" onClick={() => checkedAllInventory()} />
                                        </th>
                                        <th scope="col">Nama</th>
                                        <th scope="col">SKU</th>
                                        <th scope="col">Merek</th>
                                        <th scope="col">Cabang</th>
                                        <th scope="col">Stok</th>
                                        <th scope="col">Satuan</th>
                                        <th scope="col">Dialokasikan</th>
                                        <th scope="col">Onhand</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {productInventoryList.map((element, index) => {
                                        let allocated = !isNaN(parseFloat(element.allocated)) ? parseFloat(element.allocated) : 0;
                                        return (
                                          <tr key={element.id}>
                                            <th scope="row">
                                              {parseFloat(element.stocks) - allocated > 0 ? (
                                                <input
                                                  type="checkbox"
                                                  id={`checkBoxOne${element.id}`}
                                                  defaultChecked={element.checked === null ? false : element.checked}
                                                  className="dataCheckboxInventory form-check-input"
                                                  onChange={(e) => {
                                                    if (e.target.checked) {
                                                      setProductInventoryList((val) => {
                                                        return val.map((el) => (el.id === element.id ? { ...el, checked: true } : el));
                                                      });
                                                    } else {
                                                      setProductInventoryList((val) => {
                                                        return val.map((el) => (el.id === element.id ? { ...el, checked: false } : el));
                                                      });
                                                    }
                                                  }}
                                                />
                                              ) : null}
                                            </th>
                                            <td>
                                              <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                  {element.inv_branch_varian && element.inv_branch_varian.pvar_image ? (
                                                    <img src={element.inv_branch_varian.pvar_image === "" ? logo : `${api.MEDIA_URL}/media/${element.inv_branch_varian.pvar_image}`} alt="" className="avatar-xs rounded-circle" />
                                                  ) : (
                                                    <div className="flex-shrink-0 avatar-xs me-2">
                                                      <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{element.inv_branch_product.name.charAt(0)}</div>
                                                    </div>
                                                  )}
                                                </div>
                                                <div className="flex-grow-1 ms-2 name">{element.inv_branch_product.name && element.inv_branch_product.name}</div>
                                              </div>
                                            </td>
                                            <td>{element.inv_branch_varian && element.inv_branch_varian.sku}</td>
                                            <td>{element.inv_branch_product && element.inv_branch_product.product_brand && element.inv_branch_product.product_brand.name}</td>
                                            <td>{element.inv_branch_varian && element.inv_branch_branch.name}</td>
                                            <td className="text-center fw-semibold text-muted">{parseFloat(element.stocks)}</td>
                                            <td className="text-center text-muted">{element?.inv_branch_product?.product_uom?.name}</td>
                                            <td className="text-center fw-semibold text-muted">{!isNaN(parseFloat(element.allocated)) ? parseFloat(element.allocated) : 0}</td>
                                            <td className="text-center fw-semibold">{!isNaN(parseFloat(element.allocated)) ? parseFloat(element.stocks) - parseFloat(element.allocated) : 0}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          Tutup
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary add-btn me-2"
                          id="create-btn"
                          onClick={() => {
                            transferMultiple();
                          }}
                        >
                          <i className="ri-archive-line me-1 align-bottom "></i> Transfer
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalTransfer" isOpen={modalTransfer} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleTransfer}>
                    TRANSFER BARANG DARI {validation?.values?.branch?.label}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody>
                        <Row>
                          <Col lg={4} sm={4}>
                            <div className="mb-3">
                              <Select
                                name="toBranch"
                                placeholder="Select Branch Destination"
                                value={validation.values.toBranch}
                                onChange={(e) => {
                                  validation.setFieldValue("toBranch", e);
                                }}
                                options={branchList}
                              ></Select>
                              {validation.touched.toBranch && validation.errors.toBranch && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.toBranch}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="shipment_carrier"
                                placeholder="Select Shipping Carrier"
                                value={validation.values.shipment_carrier}
                                onChange={(e) => {
                                  validation.setFieldValue("shipment_carrier", e);
                                }}
                                options={shipmentCarrierList}
                              ></Select>
                              {validation.touched.shipment_carrier && validation.errors.shipment_carrier && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.shipment_carrier}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="shipment_method"
                                placeholder="Shipping Method"
                                value={validation.values.shipment_method}
                                onChange={(e) => {
                                  validation.setFieldValue("shipment_method", e);
                                }}
                                options={shipmentMethodList}
                              ></Select>
                              {validation.touched.shipment_method && validation.errors.shipment_method && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.shipment_method}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Input name="shipment_amount" id="shipment_amount-field" className="form-control" placeholder="Enter Shipment Cost" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.shipment_amount} invalid={validation.touched.shipment_amount && validation.errors.shipment_amount ? true : false} />
                              {validation.touched.shipment_amount && validation.errors.shipment_amount ? <FormFeedback type="invalid">{validation.errors.shipment_amount}</FormFeedback> : null}
                            </div>
                            <div className="mb-3">
                              <Input name="shipment_code" id="shipment_code-field" className="form-control" placeholder="Enter Shipment Code" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.shipment_code} invalid={validation.touched.shipment_code && validation.errors.shipment_code ? true : false} />
                              {validation.touched.shipment_code && validation.errors.shipment_code ? <FormFeedback type="invalid">{validation.errors.shipment_code}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 d-flex justify-content-between">
                              <Label htmlFor="education" className="form-label">
                                Transfer Document
                              </Label>
                              <button
                                type="button"
                                className="btn btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  toggleMedia();
                                }}
                              >
                                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </div>
                            {invDocImg.map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3">
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                      <div className="me-2">
                                        <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                      </div>
                                      <div className="text-truncate">{f.filename}</div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            handleDeleteFile(f);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                            <div className="mb-3">
                              <Label htmlFor="address-field" className="form-label">
                                Keterangan
                              </Label>
                              <Input type="textarea" className="form-control" id="description" placeholder="Enter Inbound Description " name="description" rows={3} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                              {validation.touched.description && validation.errors.description && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.description}
                                </small>
                              )}
                            </div>
                          </Col>
                          <Col lg={8} sm={8}>
                            <div>
                              <Table className="invoice-table table-borderless table-nowrap mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "20px" }}>
                                      #
                                    </th>
                                    <th scope="col" style={{ width: "400px" }}>
                                      Detail Produk
                                    </th>
                                    <th scope="col" className="text-center" style={{ width: "100px" }}>
                                      Quantity
                                    </th>
                                    <th scope="col" className="text-start" colSpan={2}>
                                      Transfer Quantity
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {productInventoryDetailItem.map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start vertical-align-center">
                                          {!isEdit ? (
                                            <Input name={`productInventoryDetailItem.${i}.id`} readOnly={true} value={productInventoryDetailItem[i].item.label ?? ""} placeholder="" />
                                          ) : (
                                            <Select
                                              name={`productInventoryDetailItem.${i}.id`}
                                              placeholder="Select Product"
                                              value={productInventoryDetailItem[i].item ?? ""}
                                              onChange={(e) => {
                                                let element = e.data.inv_branch_varian;
                                                let prod = e.data.inv_branch_product;
                                                let option_name = "";
                                                element.pvar_options &&
                                                  element.pvar_options.forEach((i) => {
                                                    option_name += i.name + "/";
                                                  });
                                                let allocated = !isNaN(parseFloat(e.data.allocated)) ? parseFloat(e.data.allocated) : 0;
                                                let data = {
                                                  detailId: e.data.id,
                                                  itemId: element.id,
                                                  item: { label: prod.name + " " + option_name.slice(0, -1) + " - " + element.barcode, value: element.id, name: prod.name + " " + option_name.slice(0, -1), sku: element.sku, barcode: element.barcode, price: element.price, brandId: element.brandId, productId: prod.id },
                                                  amount: parseFloat(element.price),
                                                  quantity: parseFloat(e.data.stocks) - allocated,
                                                  onhand: parseFloat(e.data.stocks) - allocated,
                                                  total: 0,
                                                  name: prod.name,
                                                  sku: element.sku,
                                                  barcode: element.barcode,
                                                  brandId: element.brandId,
                                                };
                                                let newState = [...productInventoryDetailItem];
                                                newState[i] = data;
                                                setProductInventoryDetailItem(newState);
                                              }}
                                              options={productSelectInventoryList}
                                            ></Select>
                                          )}
                                        </td>
                                        <td className="text-center" valign="middle">
                                          {productInventoryDetailItem[i].onhand}
                                        </td>
                                        <td className="text-center vertical-align-center">
                                          <div className="input-step ">
                                            <button
                                              type="button"
                                              className="minus bg-soft-success"
                                              onClick={() => {
                                                productInventoryDetailItem[i].quantity = productInventoryDetailItem[i].quantity > 0 ? productInventoryDetailItem[i].quantity - 1 : productInventoryDetailItem[i].quantity;
                                                validation.setFieldValue(`productInventoryDetailItem.${i}.quantity`, productInventoryDetailItem[i].quantity);
                                              }}
                                            >
                                              –
                                            </button>
                                            <Input
                                              name={`productInventoryDetailItem.${i}.quantity`}
                                              placeholder="Qty"
                                              type="text"
                                              className=" product-quantity border-0"
                                              style={{ width: "80px" }}
                                              value={productInventoryDetailItem[i].quantity || 0}
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) => {
                                                if (!isNaN(parseFloat(e.target.value))) {
                                                  let qty = e.target.value;
                                                  if (qty > productInventoryDetailItem[i].onhand) {
                                                    qty = productInventoryDetailItem[i].onhand;
                                                  }
                                                  validation.setFieldValue(`productInventoryDetailItem.${i}.quantity`, qty);
                                                  productInventoryDetailItem[i].quantity = qty;
                                                } else {
                                                  validation.setFieldValue(`productInventoryDetailItem.${i}.quantity`, 0);
                                                  productInventoryDetailItem[i].quantity = 0;
                                                }
                                              }}
                                              onBlur={validation.handleBlur}
                                            />
                                            <button
                                              type="button"
                                              className="plus bg-soft-success"
                                              onClick={() => {
                                                productInventoryDetailItem[i].quantity = productInventoryDetailItem[i].quantity >= productInventoryDetailItem[i].onhand ? productInventoryDetailItem[i].onhand : productInventoryDetailItem[i].quantity + 1;
                                                validation.setFieldValue(`productInventoryDetailItem.${i}.quantity`, productInventoryDetailItem[i].quantity);
                                              }}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleTransfer();
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Transfer Product" : "Transfer Product"}
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalTransferProduction" isOpen={modalOutbound} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleOutbound}>
                    PENGELUARAN BARANG {validationOutbound?.values?.branch?.label} &nbsp;
                    {(loading || productInventoryBranchLoading) && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationOutbound.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody>
                        <Row>
                          <Col lg={3} sm={3}>
                            <div className="mb-3">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Tgl Pengeluaran"
                                options={{
                                  mode: "single",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  validationOutbound.setFieldValue("transactionat", dateStr);
                                }}
                                value={validationOutbound.values.transactionat}
                              />
                              {validationOutbound.touched.transactionat && validationOutbound.errors.transactionat && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validationOutbound.errors.transactionat}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="branch"
                                placeholder="Pilih Cabang / Proyek"
                                value={validationOutbound.values.branch}
                                onChange={(e) => {
                                  validationOutbound.setFieldValue("branch", e);
                                  validationOutbound.setFieldValue("items", []);
                                  setBranchIdSelected(e.value);
                                  const param = { branchId: e.value, type: "inbound-product" };
                                  dispatch(onGetProductInventoryBranches(param));
                                }}
                                options={branchList}
                              ></Select>
                              {validationOutbound.touched.branch && validationOutbound.errors.branch && (
                                <small className="text-danger" type="invalid">
                                  {validationOutbound.errors.branch}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="block"
                                placeholder="Blok"
                                value={validationOutbound.values.block}
                                onChange={(e) => {
                                  validationOutbound.setFieldValue("block", e);
                                  validationOutbound.setFieldValue("items", "");
                                  validationOutbound.setFieldValue("civilBudget", "");
                                  let arrUnit = [];
                                  if (productVarians.length) {
                                    productVarians.forEach((item) => {
                                      const varian = item.pvar_product ? item.pvar_product : "";
                                      const category = varian.product_category ? varian.product_category.name : "";
                                      const blck = varian.product_block ? varian.product_block.id : "";
                                      const branch = varian.branchId ? varian.branchId : "";
                                      if (blck === e.value && branch === branchIdSelected) {
                                        const blck_name = varian.product_block ? varian.product_block.name : "";
                                        const name = blck_name + "-" + varian.name;
                                        const id = item.id;
                                        const barcode = item.barcode;
                                        const sku = item.sku;
                                        const brandId = item.brandId;
                                        const productId = item.productId;
                                        arrUnit.push({ label: name, name: name, barcode: barcode, sku: sku, value: id, brandId: brandId, productId: productId });
                                      }
                                    });
                                  }
                                  validationOutbound.setFieldValue("unit", arrUnit);
                                }}
                                options={blockList}
                              ></Select>
                              {validationOutbound.touched.block && validationOutbound.errors.block && (
                                <small className="text-danger" type="invalid">
                                  {validationOutbound.errors.block}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="unit"
                                isDisabled={validationOutbound.values.block.value === null || validationOutbound.values.block.value === "" ? true : false}
                                value={validationOutbound.values.unit}
                                placeholder="Blok Rumah Terkait"
                                isMulti
                                onChange={(opt, { option }) => {
                                  validationOutbound.setFieldValue("items", []);
                                  validationOutbound.setFieldValue("civilBudget", "");
                                  let newOpts = opt;
                                  if (option && option.value === "all") {
                                    let filteredOptions = clone(productList);
                                    filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                    newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                  }
                                  validationOutbound.setFieldValue("unit", newOpts);
                                }}
                                options={productList}
                                noOptionsMessage={(e) => "Type to get option"}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Select
                                name="civilBudget"
                                value={validationOutbound.values.civilBudget}
                                placeholder="Pilih item Anggaran"
                                onChange={(e) => {
                                  validationOutbound.setFieldValue("civilBudget", e);
                                  handleTransferDetailAddByBudget(e);
                                }}
                                options={civilBudgetMaterialList}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Link
                                to="#"
                                className="btn btn-soft-success fw-medium w-100"
                                id="add-item"
                                onClick={() => {
                                  handleTransferDetailAdd();
                                }}><i className="ri-add-fill me-1 align-bottom"></i> Material
                              </Link>
                            </div>
                            <div className="mb-3 d-flex justify-content-between">
                              <Label htmlFor="education" className="form-label">
                                Dokumen
                              </Label>
                              <button
                                type="button"
                                className="btn btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  toggleMedia();
                                }}
                              >
                                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </div>
                            {invDocImg.map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3">
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                      <div className="me-2">
                                        {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                          <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                        ) : (
                                          <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                            <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                          </Link>
                                        )}
                                      </div>
                                      <div className="text-truncate">{f.originalname}</div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            handleDeleteFile(f);
                                          }}>
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                            <div className="mb-3">
                              <Label htmlFor="address-field" className="form-label">
                                Keterangan
                              </Label>
                              <Input type="textarea" className="form-control" id="description" placeholder="Enter Inbound Description " name="description" rows={3} value={validationOutbound.values.description ?? ""} onBlur={validationOutbound.handleBlur} onChange={validationOutbound.handleChange} invalid={validationOutbound.touched.description && validationOutbound.errors.description ? true : false} />
                              {validationOutbound.touched.description && validationOutbound.errors.description && (
                                <small className="text-danger" type="invalid">
                                  {validationOutbound.errors.description}
                                </small>
                              )}
                            </div>
                          </Col>
                          <Col lg={9} sm={9} className="p-3">
                            <SimpleBar className="table-responsive table-card ps-1" style={{ height: 100 - 40 + "vh" }}>
                              <Table className="invoice-table table-borderless mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "2%" }}>
                                      #
                                    </th>
                                    <th scope="col" className="text-center" style={{ minWidth: "80%" }}>
                                      Material & Pekerjaan
                                    </th>
                                    <th scope="col" className="text-center" style={{ minWidth: "20%" }}>
                                      Jumlah
                                    </th>
                                    <th scope="col" className="text-center" style={{ width: "5%" }}></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {validationOutbound.values.items && validationOutbound.values.items.map((o, i) => {
                                      let typeLabel;
                                      let type = o.type;
                                      let hasMaterial = false;
                                      switch (type) {
                                        case "BANGUNAN":
                                          typeLabel = <span className="badge text-uppercase badge-soft-info">{type}</span>;
                                          hasMaterial = true;
                                          break;
                                        case "INFRASTRUKTUR":
                                          typeLabel = <span className="badge text-uppercase badge-soft-success">{type}</span>;
                                          hasMaterial = true;
                                          break;
                                        case "UPAH":
                                          typeLabel = <span className="badge text-uppercase badge-soft-warning">{type}</span>;
                                          hasMaterial = true;
                                          break;
                                        default:
                                          typeLabel = <span className="badge text-uppercase badge-soft-primary">LAIN-LAIN</span>;
                                          hasMaterial = false;
                                          break;
                                      }
                                      return (
                                        <tr key={"transferDetailItem-" + i} className="product">
                                          <th scope="row" className="product-id">
                                            {i + 1}
                                          </th>
                                          <td className="text-start" style={{ verticalAlign: "middle" }}>
                                            <div className="hstack">
                                              <div className="mb-2 me-3 col-auto w-50">
                                                <Select
                                                  name="item"
                                                  value={validationOutbound.values && validationOutbound.values.items ? validationOutbound.values.items[i].item : {}}
                                                  placeholder="Pilih Material"
                                                  onChange={(e) => {
                                                    if (e.item) {
                                                      validationOutbound.values.items[i].item = {
                                                        label: e.item.label,
                                                        value: e.item.value,
                                                        name: e.item.label,
                                                        sku: e.item.sku,
                                                        uom: e.uom,
                                                        barcode: e.item.barcode,
                                                        amount: 0,
                                                        brandId: e.brandId,
                                                        productId: e.item.productId,
                                                      };
                                                      validationOutbound.values.items[i].name = e.item.label;
                                                      validationOutbound.values.items[i].sku = e.item.label;
                                                      validationOutbound.values.items[i].barcode = e.item.barcode;
                                                      validationOutbound.values.items[i].itemId = e.item.value;
                                                      validationOutbound.values.items[i].brandId = e.brandId;
                                                      validationOutbound.values.items[i].amount = parseFloat(e.item.price || 0);
                                                      validationOutbound.values.items[i].detailId = e.detailId;
                                                      validationOutbound.values.items[i].disable = e.onhand > 0 ? false : true;
                                                      validationOutbound.values.items[i].quantity = e.onhand;
                                                      validationOutbound.values.items[i].onhand = e.onhand;
                                                      validationOutbound.values.items[i].uom = e.uom;
                                                    } else {
                                                      validationOutbound.values.items[i].item = e;
                                                      validationOutbound.values.items[i].name = e.label;
                                                      validationOutbound.values.items[i].sku = e.sku;
                                                      validationOutbound.values.items[i].barcode = e.barcode;
                                                      validationOutbound.values.items[i].itemId = e.value;
                                                      validationOutbound.values.items[i].brandId = e.brandId;
                                                      validationOutbound.values.items[i].amount = parseFloat(e.price);
                                                      validationOutbound.values.items[i].detailId = e.productInventoryBranchId;
                                                      validationOutbound.values.items[i].disable = e.onhand > 0 ? false : true;
                                                      validationOutbound.values.items[i].quantity = e.onhand;
                                                      validationOutbound.values.items[i].onhand = e.onhand;
                                                      validationOutbound.values.items[i].uom = e.uom;
                                                    }
                                                    validationOutbound.setFieldValue("items", validationOutbound.values.items);
                                                  }}
                                                  options={materialList}
                                                ></Select>
                                              </div>
                                              <div className="mb-2 col-auto w-50 pe-2">
                                                <Select
                                                  name="item"
                                                  value={validationOutbound.values && validationOutbound.values.items ? { label: validationOutbound.values.items[i].cvl_account_job } : {}}
                                                  style={{ minWidth: "200px" }}
                                                  placeholder="Pilih Pekerjaan"
                                                  onChange={(e) => {
                                                    validationOutbound.values.items[i].cvlAccountId = e.cvlAccountId;
                                                    validationOutbound.values.items[i].cvlBudgetDetailId = e.cvlBudgetDetailId;
                                                    validationOutbound.values.items[i].cvlBudgetId = e.cvlBudgetId;
                                                    validationOutbound.values.items[i].cvl_account_job = e.cvl_account_job;
                                                    validationOutbound.setFieldValue("items", validationOutbound.values.items);
                                                  }}
                                                  options={civilBudgetList}
                                                ></Select>
                                              </div>
                                            </div>
                                            <em className="mb-0 fs-12 text-muted">
                                              {typeLabel} {validationOutbound.values.items[i].cvl_account} 
                                              <span className={hasMaterial ? "" : "d-none"}>, Stock : {validationOutbound.values.items[i].onhand} {validationOutbound.values.items[i].uom}
                                              </span>
                                            </em>
                                          </td>
                                          <td style={{ verticalAlign: "top" }}>
                                            <div className="input-step ms-1">
                                              <button
                                                type="button"
                                                className="minus"
                                                disabled={validationOutbound.values.items[i].disable}
                                                onClick={() => {
                                                  handleBtnQtyDetail("reduce", i);
                                                  validationOutbound.setFieldValue("items", validationOutbound.values.items);
                                                }}
                                              >
                                                –
                                              </button>
                                              <Input
                                                name="quantity"
                                                disabled={validationOutbound.values.items[i].disable}
                                                placeholder="Qty"
                                                type="text"
                                                className="product-quantity border-0"
                                                style={{ width: "90px" }}
                                                onFocus={(e) => e.target.select()}
                                                value={validationOutbound.values && validationOutbound.values.items ? validationOutbound.values.items[i].quantity : validationOutbound.values.items[i].onhand}
                                                onChange={(e) => {
                                                  handleQuantityDetail(e, i);
                                                  validationOutbound.setFieldValue("items", validationOutbound.values.items);
                                                }}
                                                onBlur={validationOutbound.handleBlur}
                                              />
                                              <button
                                                type="button"
                                                className="plus"
                                                disabled={validationOutbound.values.items[i].disable}
                                                onClick={() => {
                                                  handleBtnQtyDetail("add", i);
                                                  validationOutbound.setFieldValue("items", validationOutbound.values.items);
                                                }}
                                              >
                                                +
                                              </button>
                                            </div>
                                          </td>
                                          <td className={"product-removal"} style={{ verticalAlign: "top" }}>
                                            <Link
                                              to="#"
                                              className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                              onClick={() => {
                                                onClickDeleteDetailItem(i);
                                              }}
                                            >
                                              <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                            </Link>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </Table>
                            </SimpleBar>
                          </Col>
                        </Row>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleOutbound();
                          }}>
                          CLOSE
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEditOutbound ? "UPDATE PENGELUARAN BARANG" : "SIMPAN PENGELUARAN BARANG"}
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
                    Transfer Histories
                  </ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info &&
                          info.transfer_history &&
                          info.transfer_history.map((item, i) => {
                            return (
                              <div key={i} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item.transfer_history_createdby && item.transfer_history_createdby.employee_image && item.transfer_history_createdby.employee_image.path ? (
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.transfer_history_createdby.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.transfer_history_createdby.name.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item.transfer_history_createdby.name}</h6>
                                        <p className="fw-normal text-muted mb-1">
                                          Change transfer status to <span className="fw-semibold text-info">{item.transfer_history_status.name}</span> with note:
                                        </p>
                                        <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                        <small className="text-muted">{moment(item.createdat, "YYYY/MM/DD HH:mm:ss").fromNow()}</small>
                                      </div>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalHistory(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    ACTION CONFIRMATION
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{transfer && transfer.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Transfer Detail
                  </ModalHeader>
                  {transfer !== undefined && transfer !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fw-semibold">{transfer.client && transfer.client.label}</h6>
                                  <p className="mb-1">{transfer.company && transfer.company.label}</p>
                                  <p className="mb-1">{transfer.department && transfer.department.label}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Transfer No</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{transfer.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(transfer.transactionat)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col">Detail Produk</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Satuan</th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(productInventoryDetailItem || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td>{o.quantity}</td>
                                        <td>{o.uom}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {transfer.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <div>
                                <p className="mb-0">{transfer.user}</p>
                              </div>
                            </div>
                          </CardBody>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              {(transfer.transfer_file || []).map((f, i) => {
                                if (f.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <Col lg={3} xs={3} key={i}>
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                        <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                      ) : (
                                        <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      )}
                                    </Col>
                                  );
                                }
                              })}
                            </Row>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalDetail(false);
                        }}
                      >
                        Tutup
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={transfer} />
      </Container>
    </div>
  );
};

export default Transfer;
